import { render, staticRenderFns } from "./CmgRecentAndFavoriteOrdersToggle.vue?vue&type=template&id=70a90f44&scoped=true&lang=pug&"
import script from "./cmg-recent-and-favorite-orders-toggle.ts?vue&type=script&lang=ts&"
export * from "./cmg-recent-and-favorite-orders-toggle.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRecentAndFavoriteOrdersToggle.vue?vue&type=style&index=0&id=70a90f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a90f44",
  null
  
)

export default component.exports